import React from 'react';
import './ButtonForm.css';

interface ButtonFormProps {
  toggledButtonsMajorA: Set<string>;
  setToggledButtonsMajorA: React.Dispatch<React.SetStateAction<Set<string>>>;
  toggledButtonsMajorB: Set<string>;
  setToggledButtonsMajorB: React.Dispatch<React.SetStateAction<Set<string>>>;
  enableAllButtonMajorA?: boolean;
  enableAllButtonMajorB?: boolean;
}

const allMajorAButtonLabel = 'Všechny obory';
const allMajorBButtonLabel = 'Všechny úvazky';
const majorAButtons = [allMajorAButtonLabel, 'Strojní', 'Elektro', 'Informatika', 'Ekonomie', 'Chemie', 'Stavebnictví', 'Ostatní'];
const majorBButtons = [allMajorBButtonLabel, 'Plný úvazek', 'Částečný úvazek', 'Diplomka', 'Stáž', 'Brigáda'];

const toggleButtonSet = (
  prevState: Set<string>,
  buttonId: string,
  enableAllButton: boolean,
  allButtonLabel: string,
) => {
  if (enableAllButton && buttonId === allButtonLabel) {
    return new Set([allButtonLabel]);
  }

  const newState = new Set(prevState);

  if (enableAllButton) {
    newState.delete(allButtonLabel);
  }

  if (newState.has(buttonId)) {
    newState.delete(buttonId);
  } else {
    newState.add(buttonId);
  }

  if (enableAllButton && newState.size === 0) {
    newState.add(allButtonLabel);
  }

  return newState;
};

const ButtonForm: React.FC<ButtonFormProps> = ({
  toggledButtonsMajorA,
  setToggledButtonsMajorA,
  toggledButtonsMajorB,
  setToggledButtonsMajorB,
  enableAllButtonMajorA = false,
  enableAllButtonMajorB = false,
}) => {
  const visibleMajorAButtons = enableAllButtonMajorA
    ? majorAButtons
    : majorAButtons.filter((button) => button !== allMajorAButtonLabel);

  const visibleMajorBButtons = enableAllButtonMajorB
    ? majorBButtons
    : majorBButtons.filter((button) => button !== allMajorBButtonLabel);

  return (
    <form>
      <div className="obor-container">
        <h4>Filtrovat podle oboru</h4>
        {visibleMajorAButtons.map((num) => {
          const buttonId = `${num}`;

          return (
            <button
              key={num}
              id={buttonId}
              type="button"
              onClick={() => setToggledButtonsMajorA((prevState) => toggleButtonSet(prevState, buttonId, enableAllButtonMajorA, allMajorAButtonLabel))}
              className="button"
              style={{
                backgroundColor: toggledButtonsMajorA.has(buttonId) ? '#1b75bb' : 'white',
                color: toggledButtonsMajorA.has(buttonId) ? 'white' : 'black',
              }}
            >
              {num}
            </button>
          );
        })}
      </div>
      <div className="obor-container">
        <h4>Filtrovat podle úvazku</h4>
        {visibleMajorBButtons.map((num) => {
          const buttonId = `${num}`;

          return (
            <button
              key={num}
              id={buttonId}
              type="button"
              onClick={() => setToggledButtonsMajorB((prevState) => toggleButtonSet(prevState, buttonId, enableAllButtonMajorB, allMajorBButtonLabel))}
              className="button"
              style={{
                backgroundColor: toggledButtonsMajorB.has(buttonId) ? '#1b75bb' : 'white',
                color: toggledButtonsMajorB.has(buttonId) ? 'white' : 'black',
              }}
            >
              {num}
            </button>
          );
        })}
      </div>
    </form>
  );
};

export default ButtonForm;
